export default {
  header: {
    title: 'Nutze deine Punkte',
    balance: '{{value}} Pkt. verfügbar',
  },
  option_label: '{{value}} Pkt.',
  buttons: {
    none: 'Keine',
  },
  toasts: {
    enabled: 'Loyalty Punkte erfolgreich angewendet',
    removed: 'Loyalty Punkte entfernt',
  },
};
